import { Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  WelcomePageWidgetPanel,
  SeeMoreLink,
} from 'src/components/dashboard/home/commonComponents';
import { gridUnit } from 'src/design/styleguide/common/measurements';
import { settingsUrl } from 'src/utils/pageUrls';
import { userSelector } from 'scripts/redux/actions/user';
import Text from 'src/design/styleguide/text/Text';
import { hasMinorDetails } from 'scripts/utilities/userAccountHelper';

const SectionHeading = styled(Text).attrs({
  as: 'h3',
  fontSize: '2x-small',
  fontWeight: 'medium',
})`
  margin: 0 0 ${gridUnit * 4}px;
`;

const AccountSettingsWidgetPanel = styled(WelcomePageWidgetPanel)`
  padding-top: ${gridUnit * 6}px;
`;

const SettingsContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(92px, 0.42fr) minmax(0, 1fr);
  column-gap: ${gridUnit * 5}px;
  row-gap: ${gridUnit * 2}px;
`;

const SettingName = styled(Text).attrs({
  as: 'div',
  fontSize: '4x-small',
})`
  color: var(--bx-color---grey-800);
`;

const SettingValue = styled(Text).attrs({
  as: 'div',
  fontSize: '4x-small',
})`
  min-width: 0;
  overflow-wrap: anywhere;
`;

const AccountSettingsPanel = connect(userSelector)(({
  className,
  settingsHref = settingsUrl(),
  testRef = 'account-settings-panel',
  user,
}) => {
  const showMinorDetails = hasMinorDetails(user);
  return (
    <AccountSettingsWidgetPanel
      className={className}
      title="Account Settings"
      action={<SeeMoreLink href={settingsHref} />}
      testRef={testRef}
    >
      <SectionHeading>My Details</SectionHeading>
      <SettingsContainer>
        {showMinorDetails && (
          <Fragment>
            <SettingName>
              <strong>Minor's Details:</strong>
            </SettingName>
            <SettingValue />

            <SettingName>Trust Name</SettingName>
            <SettingValue>{user.minorDetails.trustName}</SettingValue>

            <SettingName>Minor's Full Name</SettingName>
            <SettingValue>
              {[
                user.minorDetails.firstName,
                user.minorDetails.middleName,
                user.minorDetails.lastName,
              ]
                .filter((ele) => ele)
                .join(' ')}
            </SettingValue>

            <SettingName>
              <strong>Adult's Details:</strong>
            </SettingName>
            <SettingValue />
          </Fragment>
        )}

        <SettingName>First Name</SettingName>
        <SettingValue testRef="account-settings-panel-first-name">
          {user.givenName}
        </SettingValue>

        <SettingName>Email</SettingName>
        <SettingValue testRef="account-settings-panel-email">
          {user.email}
        </SettingValue>

        <SettingName>Mobile</SettingName>
        <SettingValue testRef="account-settings-panel-mobile">
          {user.mobilePhone || 'Not Provided'}
        </SettingValue>
      </SettingsContainer>
    </AccountSettingsWidgetPanel>
  );
});

export default AccountSettingsPanel;
